module.exports = __webpack_public_path__ + "static/media/github-wagyu-key-gen-screenshot.8b32999a.png";